var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VEmojiPicker',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"emojisByRow":8},on:{"select":_vm.selectEmoji,"changeCategory":_vm.handleChangeCategory}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d2d5fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Emoji.vue
// module id = null
// module chunks = 